import * as reportsCenterService from './service';

export default {
  api: { reportsCenterService },
};
